// Form validations
const validate = (values) => {
  const errors = {};
  if (!values.firstname) {
    errors.firstname = "Firstname is required";
  } else if (values.firstname.length > 15) {
    errors.firstname = "Must be 15 characters or less";
  }

  if (!values.lastname) {
    errors.lastname = "Lastname is required";
  } else if (values.lastname.length > 20) {
    errors.lastname = "Must be 20 characters or less";
  }

  if (!values.email) {
    errors.email = "Email is required";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = "Invalid email address";
  }
  if (!values.phone) {
    errors.phone = "Phone is required";
  } else if (values.phone.length !== 10) {
    errors.phone = "Invalid phone number";
  }
  if (!values.password) {
    errors.password = "Password is required";
  } else if (values.password < 5) {
    errors.password = "Not strong password";
  }
  if (!values.password_confirmation) {
    errors.password_confirmation = "Confirmation password is required";
  } else if (values.password_confirmation !== values.password) {
    errors.password_confirmation = "Password not match";
  }
  if (!values.address) {
    errors.address = "Address is required";
  }

  return errors;
};

export const loginValidation = (values) => {
  let errors = {};
  if (!values.email) {
    errors.email = "Email is required";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = "Invalid email address";
  }
  if (!values.password) {
    errors.password = "Password is required";
  } else if (values.password < 5) {
    errors.password = "Not strong password";
  }
  return errors;
};
export const addProductValidation = (values) => {
  let errors = {};
  if (!values.category || values.category === "none") {
    errors.category = "Category is required";
  }
  if (!values.title) {
    errors.title = "Title is required";
  }
  if (!values.price) {
    errors.price = "Price is required";
  }
  if (!values.description) {
    errors.description = "Description is required";
  }
  if (!values.image) {
    errors.image = "Image is required";
  }
  return errors;
};
export default validate;
